import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/auth'
import { instagramService } from '@/services'
import { LoadingState, ErrorState, NoDataState, InstagramAnalyticsDashboard } from '@/components/accounts'
import type { InstagramAnalyticsInsights } from '@/types'

export function InstagramAccountPage() {
  const { uuid } = useParams<{ uuid: string }>()
  const { isAuthenticated, isLoading: authLoading } = useAuth()
  
  const { data, isLoading, error } = useQuery({
    queryKey: ['instagram-analytics', uuid],
    queryFn: () => instagramService.getAccountAnalytics(uuid!),
    enabled: !!uuid && isAuthenticated && !authLoading,
    retry: 1,
    refetchOnWindowFocus: false,
  })

  if (isLoading) {
    return <LoadingState />
  }

  if (error) {
    const errorMessage = error instanceof Error ? error.message : 'An error occurred'
    if (errorMessage.includes('not found') || errorMessage.includes('404')) {
      return <ErrorState message="Instagram analytics record not found" />
    }
    if (errorMessage.includes('Analytics not available') || errorMessage.includes('422')) {
      return <ErrorState message="Analytics processing failed. Please make a new request." />
    }
    return <ErrorState message={errorMessage} />
  }

  if (!data || Object.keys(data).length === 0) {
    return <NoDataState />
  }

  return <InstagramAnalyticsDashboard data={data as InstagramAnalyticsInsights} />
} 


